const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function parseInviteEmails(value) {
    const emails = typeof value === 'string'
        ? value
            .split(/[,\n]/)
            .map((email) => email.trim())
            .filter(Boolean)
        : [];

    if (emails.length === 0 || emails.some((email) => !EMAIL_PATTERN.test(email))) {
        return null;
    }

    return emails;
}
